
import { useCallback, useEffect, useState } from 'react';

// Version 2 starts with all exclusions enabled.
// The new key resets preferences once after this update.
const STORAGE_KEY = 'faunatrack-animal-exclusions-v2';

const DEFAULTS = {
  excludeBats: true,
  excludeRatsMice: true,
  excludeShrews: true
};

function loadExclusions() {
  try {
    const parsed = JSON.parse(
      localStorage.getItem(STORAGE_KEY) || '{}'
    );

    return {
      ...DEFAULTS,
      ...Object.fromEntries(
        Object.keys(DEFAULTS)
          .filter(key => typeof parsed[key] === 'boolean')
          .map(key => [key, parsed[key]])
      )
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function useAnimalExclusions() {
  const [exclusions, setExclusions] = useState(loadExclusions);

  useEffect(() => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(exclusions)
      );
    } catch {
      // Filters still work if storage is unavailable.
    }
  }, [exclusions]);

  const setExclusion = useCallback((key, checked) => {
    if (!Object.prototype.hasOwnProperty.call(DEFAULTS, key)) {
      return;
    }

    setExclusions(previous => ({
      ...previous,
      [key]: checked
    }));
  }, []);

  return { exclusions, setExclusion };
}

export function appendExclusionParams(params, exclusions) {
  for (const key of Object.keys(DEFAULTS)) {
    if (exclusions[key]) {
      params.set(key, 'true');
    }
  }
}
